import { compileTheme } from './compile.js';
import { tokens } from './tokens.js';
export { compileTheme } from './compile.js';
const base = {
    accentText: '#ffffff',
    card: tokens.color.card,
    border: tokens.color.border,
    text: tokens.color.text,
    textMuted: tokens.color.textMuted,
    success: tokens.color.success,
    successBg: tokens.color.successBg,
    warning: tokens.color.warning,
    warningBg: tokens.color.warningBg,
    danger: tokens.color.danger,
    dangerBg: tokens.color.dangerBg,
};
/**
 * Produktova temata. Fakturace ma dva kandidaty akcentu (A emerald, B teal) —
 * oba v galerii, vybere R.B.; default je A.
 */
export const themes = [
    {
        ...base,
        name: 'reos',
        accent: tokens.color.accent.reos,
        accentSoft: '#e7eefb',
        canvas: tokens.color.canvas.reos,
        chart: [tokens.color.accent.reos, '#f0c24b', '#e8632e', '#9db9e8', '#c3cbd6'],
    },
    {
        ...base,
        name: 'kokpit',
        accent: tokens.color.accent.kokpit,
        accentSoft: '#eceafd',
        canvas: tokens.color.canvas.kokpit,
        chart: [tokens.color.accent.kokpit, '#f0c24b', '#e8632e', '#b3b4f5', '#c6c8d2'],
    },
    {
        ...base,
        name: 'fakturace-a',
        accent: tokens.color.accent.fakturaceA,
        accentSoft: '#def0e9',
        canvas: tokens.color.canvas.fakturace,
        chart: [tokens.color.accent.fakturaceA, '#f0c24b', '#e8632e', '#93cdb8', '#c5cbc9'],
    },
    {
        ...base,
        name: 'fakturace-b',
        accent: tokens.color.accent.fakturaceB,
        accentSoft: '#dcefed',
        canvas: tokens.color.canvas.fakturace,
        chart: [tokens.color.accent.fakturaceB, '#f0c24b', '#e8632e', '#8fccc7', '#c5cbc9'],
    },
];
/** Kompilace vsech temat do jednoho CSS bloku (galerie / produkty si vyberou). */
export function compileAllThemes() {
    return themes.map(compileTheme).join('\n\n');
}
//# sourceMappingURL=themes.js.map